import { render, staticRenderFns } from "./ResearchesReport.vue?vue&type=template&id=6c3a04d6&scoped=true"
import script from "./ResearchesReport.vue?vue&type=script&lang=js"
export * from "./ResearchesReport.vue?vue&type=script&lang=js"
import style0 from "./ResearchesReport.vue?vue&type=style&index=0&id=6c3a04d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3a04d6",
  null
  
)

export default component.exports